import {
  HsDefaultMaterial,
  HsShaderData,
  HsShaderObjectType,
  type HsLightStorage,
  type HsMaterial,
} from '@sibe/hyperscene';

/** A single-color material with diffuse lighting, like the legacy engine's `ColorMaterial`. */
export function makeLitMaterial(
  gl: WebGL2RenderingContext,
  red: number,
  green: number,
  blue: number,
  lights?: HsLightStorage
): HsMaterial {
  const shaderData: HsShaderData = new HsShaderData(HsShaderObjectType.single);
  if (lights !== undefined) {
    shaderData.setLightStorage(lights);
  }
  shaderData.addColor().addDepth().addNormals().addDiffuseLighting();
  const material: HsMaterial = new HsDefaultMaterial(gl, shaderData.makeShader());
  material.color.set(red, green, blue);
  return material;
}
